import { PostTimeSeriesInDto, GetTimeSeriesOutDto } from "../../../types/post-views.dto";

export const GET_POST_TIME_SERIES = "GET_POST_TIME_SERIES";
export const GET_POST_TIME_SERIES_SUCCESS = "GET_POST_TIME_SERIES_SUCCESS";
export const GET_POST_TIME_SERIES_ERROR = "GET_POST_TIME_SERIES_ERROR";
export const RESET_POST_TIME_SERIES = "RESET_POST_TIME_SERIES";

export interface GetPostTimeSeries {
  type: typeof GET_POST_TIME_SERIES;
  payload: GetTimeSeriesOutDto;
}

export interface GetPostTimeSeriesSuccess {
  type: typeof GET_POST_TIME_SERIES_SUCCESS;
  payload: PostTimeSeriesInDto;
}

export interface GetPostTimeSeriesError {
  type: typeof GET_POST_TIME_SERIES_ERROR;
  payload: string | boolean;
}

export interface ResetPostTimeSeries {
  type: typeof RESET_POST_TIME_SERIES;
  payload: null;
}

export interface State {
  data: PostTimeSeriesInDto | null;
  states: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

export const initialState: State = {
  data: null,
  states: {
    success: false,
    loading: false,
    error: false,
  },
};

export type Actions = GetPostTimeSeries | GetPostTimeSeriesSuccess | GetPostTimeSeriesError | ResetPostTimeSeries;

